import { DEVICE } from '@net0-calc/common/assets/styles';
import { ClockIcon } from '@net0-calc/common/assets/svg';
import { StepDescription, StepTitle } from '@net0-calc/common/components/ui';
import { RedAccentHeading } from 'components';
import { CalculatorFormValues } from 'common/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components/macro';
import { WizardPageProps } from '../../WizardForm/WizardForm';

const WelcomePage: React.FC<WizardPageProps<CalculatorFormValues>> = () => {
  const { t } = useTranslation();

  return (
    <Root>
      <AnimatedItem $delay={0}>
        <RedAccentHeading>
          <StepTitle dangerouslySetInnerHTML={{ __html: t('personal.pages.welcome.title') }} />
        </RedAccentHeading>
      </AnimatedItem>
      <AnimatedItem $delay={1}>
        <StepDescription dangerouslySetInnerHTML={{ __html: t('personal.pages.welcome.description') }} />
      </AnimatedItem>
      <AnimatedItem $delay={2}>
        <EstimationSection>
          <StyledClockIcon />
          <Text>{t('personal.pages.welcome.estimation')}</Text>
        </EstimationSection>
      </AnimatedItem>
    </Root>
  );
};

export default WelcomePage;

const fadeSlideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;

  @media ${DEVICE.laptop} {
    margin-bottom: 70px;
    height: auto;
    flex-grow: 1;
    justify-content: flex-start;
  }
`;

const AnimatedItem = styled.div<{ $delay: number }>`
  opacity: 0;
  animation: ${fadeSlideUp} 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: ${({ $delay }) => 0.1 + $delay * 0.15}s;
`;

const EstimationSection = styled.div`
  display: flex;
  align-items: center;
`;

const StyledClockIcon = styled(ClockIcon)`
  margin-right: 10px;
  stroke: var(--color2);
`;

const Text = styled(StepDescription)`
  margin-bottom: 0px;
`;
